import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'

const About = (props) => {
    return(
<div id="" className="container" style={{marginTop: "20px" , width: "65%", textAlign: "center"}}>
            <div id="info" className="row">
                <div className="">
                    <header>
                        <h1><strong>{props.header}</strong></h1>
                    </header>
                    <p style={{fontSize: "18px", paddingTop: "20px"}}><strong>
                        {props.body}
                             </strong>
                    </p>
                </div>
            </div>
        </div>
        )
    }
    
    export default About;